module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Selo Site Seguro")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "texto"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n      Todos os sites que utilizam certificados SSL emitidos na cadeia da AC El Salvador\n      podem utilizar o selo.\n    ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _c('form', {
    attrs: {
      "id": "formSelo",
      "onsubmit": "return false"
    }
  }, [_vm._v("\n        Endereço do site:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.urlsite),
      expression: "urlsite",
      modifiers: {
        "lazy": true
      }
    }],
    staticStyle: {
      "width": "95%",
      "border": "1px #e0e0e0 solid",
      "padding": "2px"
    },
    attrs: {
      "type": "text",
      "size": "40",
      "id": "urlselo"
    },
    domProps: {
      "value": (_vm.urlsite)
    },
    on: {
      "change": function($event) {
        _vm.urlsite = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundo),
      expression: "fundo"
    }],
    attrs: {
      "type": "radio",
      "id": "tiposelo",
      "name": "tiposelo",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.fundo, "1")
    },
    on: {
      "change": function($event) {
        _vm.fundo = "1"
      }
    }
  }), _vm._v(" Fundo claro - Grande\n  \t\t\t"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundo),
      expression: "fundo"
    }],
    attrs: {
      "type": "radio",
      "id": "tiposelo",
      "name": "tiposelo",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.fundo, "2")
    },
    on: {
      "change": function($event) {
        _vm.fundo = "2"
      }
    }
  }), _vm._v(" Fundo claro - Médio\n  \t\t\t"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundo),
      expression: "fundo"
    }],
    attrs: {
      "type": "radio",
      "id": "tiposelo",
      "name": "tiposelo",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.fundo, "3")
    },
    on: {
      "change": function($event) {
        _vm.fundo = "3"
      }
    }
  }), _vm._v(" Fundo claro - Pequeno\n  \t\t\t"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundo),
      expression: "fundo"
    }],
    attrs: {
      "type": "radio",
      "id": "tiposelo",
      "name": "tiposelo",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.fundo, "4")
    },
    on: {
      "change": function($event) {
        _vm.fundo = "4"
      }
    }
  }), _vm._v(" Fundo escuro - Grande\n  \t\t\t"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundo),
      expression: "fundo"
    }],
    attrs: {
      "type": "radio",
      "id": "tiposelo",
      "name": "tiposelo",
      "value": "5"
    },
    domProps: {
      "checked": _vm._q(_vm.fundo, "5")
    },
    on: {
      "change": function($event) {
        _vm.fundo = "5"
      }
    }
  }), _vm._v(" Fundo escuro - Médio\n  \t\t\t"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundo),
      expression: "fundo"
    }],
    attrs: {
      "type": "radio",
      "id": "tiposelo",
      "name": "tiposelo",
      "value": "6"
    },
    domProps: {
      "checked": _vm._q(_vm.fundo, "6")
    },
    on: {
      "change": function($event) {
        _vm.fundo = "6"
      }
    }
  }), _vm._v(" Fundo escuro - Pequeno\n  \t\t\t"), _c('br'), _c('br'), _vm._v("\n  \t\t\tAparência do Selo:\n  \t\t\t"), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "text-align": "center"
    },
    style: ('background-color: ' + _vm.corfundo),
    attrs: {
      "id": "exemploSelo"
    }
  }, [_c('img', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "src": 'https://selo.ca.inf.br/' + _vm.imagem
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n  \t\t\tCódigo para o Selo (JavaScript):"), _c('br'), _vm._v(" "), _c('textarea', {
    staticStyle: {
      "width": "95%",
      "border": "1px #e0e0e0 solid",
      "padding": "2px",
      "font-size": "x-small"
    },
    attrs: {
      "id": "selo1",
      "readonly": "readonly",
      "rows": "5",
      "onclick": "this.select()"
    }
  }, [_vm._v(_vm._s(_vm.seloJavascript))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n  \t\t\tCódigo para o Selo (HTML simples):"), _c('br'), _vm._v(" "), _c('textarea', {
    staticStyle: {
      "width": "95%",
      "border": "1px #e0e0e0 solid",
      "padding": "2px",
      "font-size": "x-small"
    },
    attrs: {
      "id": "selo2",
      "readonly": "readonly",
      "rows": "5",
      "onclick": "this.select()"
    }
  }, [_vm._v(_vm._s(_vm.seloHtml))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "texto"
  }, [_c('p', [_vm._v("\n      A Soluti oferece o Selo Site Seguro para certificados de equipamento (SSL). Este selo garante\n      que o site onde ele aparece utiliza certificado digital ICP-Brasil nas conexões seguras, através do protocolo HTTPS.\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n      Ao ver este selo em algum site, clique sobre ele e confirme se o site está utilizando corretamente\n      o certificado emitido pela AC El Salvador:\n      "), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "src": "https://selo.ca.inf.br/selo-soluti-grande.png",
      "alt": "site seguro"
    }
  })]), _vm._v(" "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("Quem pode utilizar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("Como instalar o selo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      A instalação do selo é simples. Basta inserir em seu site um pequeno código HTML/JavaScript e o\n      selo será exibido sempre que uma conexão HTTPS for estabelecida.\n      "), _c('br'), _c('br'), _vm._v("\n      Para criar o código para seu site, preencha as opções abaixo:\n      "), _c('br'), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4cf97420!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Selo.vue
// module id = 99
// module chunks = 0